// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#edit-report-form {
  width: 500px;
  /* .form__input-container:has(input:focus) {
    border: 1px solid purple;
  } */
}

#form-header__large-text {
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
}
#form-header__small-text {
  font-size: 16px;
  font-weight: 100;
  line-height: 1.5;
  color: #475467;
}

.form__dropdown {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 50px;
  z-index: 2;
  border: 2px solid purple;
  border-radius: 8px;
  background-color: #fff;
  font-size: 16px;
  padding: 0 10px;
  max-height: 200px;
  overflow-y: auto;
}

.form__radio-container {
  width: 80%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  font-weight: 100;
}
.form__radio-group {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center
}
.form__radio-group input {
    /* remove default checkbox inner circle */
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: #fff;
    color: #fff;
    border-radius: 50%;
    border: 1.5px solid #a9a9a9;
    width: 20px;
    height: 20px;
    position: relative;
    outline: none;
  }
.form__radio-group input:checked::after,
  .form__radio-group input:focus::after {
    /* after = inner circle of radio button */
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    background-color: #590b8a;
    border-radius: 50%;
  }
.form__breakout-checkbox-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 80%;
}

/* Breakout dates checkbox */
.form__styled-checkbox {
  /* make the native checkbox invisible */
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.form__styled-checkbox + label {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 100;
}

.form__styled-checkbox + label:before {
  /* before = box */
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid purple;
  border-radius: 5px;
}
.form__styled-checkbox:checked + label:before {
  background: #f0e9f5; /* box color when checked */
}

.form__styled-checkbox:checked + label:after {
  /* after = check */
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5.46px;
  height: 9.1px;
  border: solid purple;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.form__checkbox-description {
  padding-bottom: 15px;
  font-size: 14px;
  font-weight: 100;
  align-self: flex-start;
  width: 100%;
}
/* end customize Breakout dates checkbox */

/* Tabs */
.schedule__tabs-container {
  display: flex;
  width: 100%;
}

.schedule__tab {
  width: 50%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.schedule__tab--active {
  background: #f0e9f5;
  border-bottom: 3px solid #571c7d;
  color: darkpurple;
}
`, "",{"version":3,"sources":["webpack://./src/components/EditReportForm.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ;;KAEG;AACL;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B;AA6BF;AA3BE;IACE,yCAAyC;IACzC,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;AACA;;IAEE,yCAAyC;IACzC,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;AAEF;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,mBAAmB,EAAE,2BAA2B;AAClD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;AACA,0CAA0C;;AAE1C,SAAS;AACT;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;AACnB","sourcesContent":["#edit-report-form {\n  width: 500px;\n  /* .form__input-container:has(input:focus) {\n    border: 1px solid purple;\n  } */\n}\n\n#form-header__large-text {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28px;\n}\n#form-header__small-text {\n  font-size: 16px;\n  font-weight: 100;\n  line-height: 1.5;\n  color: #475467;\n}\n\n.form__dropdown {\n  width: 100%;\n  position: absolute;\n  left: 0;\n  bottom: 50px;\n  z-index: 2;\n  border: 2px solid purple;\n  border-radius: 8px;\n  background-color: #fff;\n  font-size: 16px;\n  padding: 0 10px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.form__radio-container {\n  width: 80%;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 100;\n}\n.form__radio-group {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-items: center;\n\n  & input {\n    /* remove default checkbox inner circle */\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-color: #fff;\n    color: #fff;\n    border-radius: 50%;\n    border: 1.5px solid #a9a9a9;\n    width: 20px;\n    height: 20px;\n    position: relative;\n    outline: none;\n  }\n  & input:checked::after,\n  & input:focus::after {\n    /* after = inner circle of radio button */\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 8px;\n    height: 8px;\n    background-color: #590b8a;\n    border-radius: 50%;\n  }\n}\n.form__breakout-checkbox-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: 80%;\n}\n\n/* Breakout dates checkbox */\n.form__styled-checkbox {\n  /* make the native checkbox invisible */\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n.form__styled-checkbox + label {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 100;\n}\n\n.form__styled-checkbox + label:before {\n  /* before = box */\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid purple;\n  border-radius: 5px;\n}\n.form__styled-checkbox:checked + label:before {\n  background: #f0e9f5; /* box color when checked */\n}\n\n.form__styled-checkbox:checked + label:after {\n  /* after = check */\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 5.46px;\n  height: 9.1px;\n  border: solid purple;\n  border-width: 0 3px 3px 0;\n  transform: rotate(45deg);\n}\n\n.form__checkbox-description {\n  padding-bottom: 15px;\n  font-size: 14px;\n  font-weight: 100;\n  align-self: flex-start;\n  width: 100%;\n}\n/* end customize Breakout dates checkbox */\n\n/* Tabs */\n.schedule__tabs-container {\n  display: flex;\n  width: 100%;\n}\n\n.schedule__tab {\n  width: 50%;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.schedule__tab--active {\n  background: #f0e9f5;\n  border-bottom: 3px solid #571c7d;\n  color: darkpurple;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
